import { DashboardAPI } from "../api";

export const createStripeSession = async ({ creditsToPurchase, customerEmail }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/create-checkout-session",
        data: {
            creditsToPurchase,
            customerEmail,
        },
    });

/** Recompute the PaymentIntent amount as (credits price + Stripe Tax) from the buyer's billing address. */
export const updatePaymentTax = async ({ paymentIntentId, address }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/update-tax",
        data: {
            paymentIntentId,
            address,
        },
    });

export const checkoutSuccess = async ({ paymentIntentId, userUid, creditsToAdd }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/checkout-success",
        data: {
            paymentIntentId,
            userUid,
            creditsToAdd,
        },
    });

export const getTransactions = async (uid, filters, lastId) =>
    DashboardAPI({
        method: "GET",
        url: `/payments/get-transactions`,
        query: {
            userUid: uid,
            types: JSON.stringify([...(filters.type || [])]),
            startRange: filters.dateRange.start,
            endRange: filters.dateRange.end,
            lastId,
        },
    });

export const addTransactionToHistory = async ({ userUid, type, credits, spentDetails = {}, transferDetails = {} }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/add-transaction",
        data: {
            userUid,
            type,
            credits,
            spentDetails,
            transferDetails,
        },
    });

export const transferLegacyCredits = async () =>
    DashboardAPI({
        method: "POST",
        url: "/payments/transfer-legacy-credits",
    });

export const unlockRunsWithLegacyCredits = async ({ analysisId, credits }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/unlock-runs-with-legacy",
        data: {
            analysisId,
            credits,
        },
    });

/** One-time Insights grant: seed availableRuns on a new analysis (server-side). */
export const seedInsightsParametricRuns = async ({ analysisId, modelId }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/seed-insights-parametric-runs",
        data: {
            analysisId,
            modelId,
        },
    });

/** One-time settle of isRxRResultsUnlocked when still unset (server-side). */
export const settleRxRResultsUnlock = async ({ modelId }) =>
    DashboardAPI({
        method: "POST",
        url: "/payments/settle-rxr-results-unlock",
        data: {
            modelId,
        },
    });

/** Whether the current user may purchase credits (dev allowlist until payments are live for all). */
export const getAllowPayments = async () =>
    DashboardAPI({
        method: "GET",
        url: "/payments/allow-payments",
    });
